module.exports = __webpack_public_path__ + "static/media/icon-supplies-shampoo.4cb75a07.svg";